export const isClient = (): boolean => typeof window !== "undefined";

export const getClientValue = (key: string): any => {
  if (!isClient() || !key) return undefined;

  return (window as any)?.[key];
};

export const existClientValue = (key: string): boolean => !!getClientValue(key);

export const resetClientValue = (key: string): boolean => {
  if (!isClient() || !key) return false;

  (window as any)[key] = undefined;
  return true;
};
